import { render, staticRenderFns } from "./studentSummary.vue?vue&type=template&id=8d3c1ca8&lang=true&"
import script from "./studentSummary.vue?vue&type=script&lang=js&"
export * from "./studentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports